export const IMAGE_SIZES = ['small', 'medium', 'large'] as const;
export const baseImageToSizeMap = {
  small: 'source',
  medium: 'sourceMedium',
  large: 'sourceLarge',
} as const;
